import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DS } from '../../components/ds';
import { BlogContextProvider, useBlogContext } from '../../contexts/BlogContext';
import { ArticleDetail } from '../../components/sections/blog/ArticleDetail';
import { BlogBreadcrumb } from '../../components/sections/blog/BlogBreadcrumb';
function truncate(text: string, max: number) {
  return text.length > max ? `${text.slice(0, max)}…` : text;
}
function ArticleDetailPageContent() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const {
    articles
  } = useBlogContext();
  const article = articles.find(a => a.id === Number(id));
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [id]);
  const goToArticles = () => navigate('/blog');
  const goHome = () => navigate('/');
  if (!article) {
    return <section style={{
      background: '#fff',
      minHeight: '100vh',
      paddingTop: '68px'
    }} data-id="element-919" data-mp="1dg0p5yg54d46">
        <BlogBreadcrumb items={[{
        label: 'Alinova',
        to: '/'
      }, {
        label: 'Blog',
        to: '/blog'
      }, {
        label: 'No encontrado'
      }]} data-id="element-920" data-mp="mwtsx86iy7f4" />
        <div style={{
        maxWidth: '600px',
        margin: '0 auto',
        padding: '80px 24px',
        textAlign: 'center'
      }} data-id="element-921" data-mp="cywaj1bcj4uf">
          <h1 style={{
          fontFamily: DS.font.heading,
          fontSize: '28px',
          fontWeight: 700,
          color: DS.color.ink,
          margin: '0 0 14px'
        }} data-id="element-922" data-mp="8znd9mh3kou4">
            Artículo no encontrado
          </h1>
          <p style={{
          fontFamily: DS.font.body,
          fontSize: '15px',
          color: DS.color.body,
          margin: '0 0 28px'
        }} data-id="element-923" data-mp="3qbpudjb574yw">
            Es posible que el enlace sea incorrecto o el artículo ya no esté
            disponible.
          </p>
          <button type="button" onClick={goToArticles} style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          padding: '12px 26px',
          borderRadius: DS.radius.pill,
          border: 'none',
          background: '#00AAD4',
          boxShadow: '0 8px 26px rgba(0, 170, 212, 0.42)',
          color: '#fff',
          fontFamily: DS.font.body,
          fontSize: '14px',
          fontWeight: 700,
          cursor: 'pointer'
        }} data-id="element-924" data-mp="32qf634ktsgja">
            Volver al blog
          </button>
        </div>
      </section>;
  }
  return <section style={{
    background: '#fff',
    minHeight: '100vh',
    paddingTop: '68px'
  }} data-id="element-925" data-mp="3bp985agxdz48">
      <BlogBreadcrumb items={[{
      label: 'Alinova',
      to: '/'
    }, {
      label: 'Blog',
      to: '/blog'
    }, {
      label: truncate(article.title, 50)
    }]} data-id="element-926" data-mp="3gnu1qr1o9kjp" />
      <div style={{
      padding: '48px 24px 80px'
    }} data-id="element-927" data-mp="d36fpzet6w2c">
        <ArticleDetail article={article} onBack={goToArticles} onHome={goHome} data-id="element-928" data-mp="1xqperthwtl5j" />
      </div>
    </section>;
}
export function ArticleDetailPage() {
  return <BlogContextProvider data-id="element-929" data-mp="26jswwf3i2m6i">
      <ArticleDetailPageContent data-id="element-930" data-mp="26kc6n8izy49g" />
    </BlogContextProvider>;
}